import i18n from 'i18next';

/**
 * Utility functions for date formatting
 */

/**
 * Calendar day key in the user's local timezone (YYYY-MM-DD).
 * Use this instead of toISOString().slice(0, 10) so dots match the grid cells.
 */
export const toLocalDateString = (input) => {
  if (input == null || input === '') return '';
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** viewMonth: "YYYY-MM" with month 1–12 */
export const rangeStringsForViewMonth = (viewMonth) => {
  const [y, m] = (viewMonth || '').split('-').map(Number);
  if (!y || !m) return { fromStr: '', toStr: '' };
  const pad = (n) => String(n).padStart(2, '0');
  const fromStr = `${y}-${pad(m)}-01`;
  const lastD = new Date(y, m, 0).getDate();
  const toStr = `${y}-${pad(m)}-${pad(lastD)}`;
  return { fromStr, toStr };
};

/** Selected date "YYYY-MM-DD" → inclusive month bounds as local YYYY-MM-DD strings */
export const rangeStringsForSelectedDate = (dateStr) => {
  const d = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(d.getTime())) return { fromStr: '', toStr: '' };
  const vm = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  return rangeStringsForViewMonth(vm);
};

/**
 * Formats a date to European format (dd/mm/yyyy)
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date string in dd/mm/yyyy format
 */
export const formatDateEuropean = (date) => {
  if (!date) return '-';

  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '-';

  return new Intl.DateTimeFormat(i18n.language || 'en', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(dateObj);
};

/**
 * Formats a date to European format without year (dd/mm)
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date string in dd/mm format
 */
export const formatDateEuropeanShort = (date) => {
  if (!date) return '-';

  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '-';

  return new Intl.DateTimeFormat(i18n.language || 'en', {
    day: '2-digit',
    month: '2-digit',
  }).format(dateObj);
};

export const formatCurrency = (value, currency = 'EUR') => {
  if (value == null || value === '') return '-';
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) return '-';
  return new Intl.NumberFormat(i18n.language || 'en', {
    style: 'currency',
    currency,
  }).format(numberValue);
};
